import React from 'react'
import { intersection } from 'lodash-es'
import { ICellRendererParams } from 'ag-grid-community'
import { DefaultCellContentWrapper } from 'view/components/datagrid'
import { ReadOnlyCollateralBasketDetailsButton } from 'view/shared/collateralBasket/ReadOnlyCollateralBasketDetailsButton'
import { ActionsButtonProps } from 'view/components/datagrid'

export function createAuditActionsRenderer(ActionsButton: React.ComponentType<ActionsButtonProps>) {
  return class ActionsRenderer extends React.Component<ICellRendererParams> {
    render() {
      const { api, node, context } = this.props

      const allLeafChildren = node.allLeafChildren ?? []
      const isGroupRow = !!node.group
      const items = node.group ? allLeafChildren.map(leaf => leaf.data) : [node.data]
      const selectedRows = api.getSelectedRows()
      const allChildSelected = intersection(items, selectedRows).length === items.length
      const shouldRenderActions = items.length > 0 && (!isGroupRow || allChildSelected)
      const basketId = items[0]?.collateralBasket?.id

      return (
        <DefaultCellContentWrapper rightAlign={true}>
          {shouldRenderActions && (
            <ActionsButton items={items} isGroupRow={isGroupRow} context={context} isCounterpartyNegotiation={false} />
          )}
          {basketId && isGroupRow && <ReadOnlyCollateralBasketDetailsButton collateralBasketId={basketId} />}
        </DefaultCellContentWrapper>
      )
    }

    refresh = () => {
      this.forceUpdate()
      return true
    }
  }
}
